import { COLUMNS_CAMIONES_VOLCADOS, COLUMNS_CAMIONES_VOLCADOS_TO_PRINT } from './constantesCamionesVolcados'
import { pdfCustomToolbarGenerator } from '../../../../../models/tools/generarPdf'
import { TablaCamionesVolcadosService } from '../servicio/tabla_camiones_volcados'
import { TABLA_CAMIONES_VOLCADOS } from '../../../../../config/tables'
import moment from 'moment'

export function actualizarDatosParaMuiTable (fechaActualizada) {
  return dispatch => {
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: TABLA_CAMIONES_VOLCADOS
    })
    TablaCamionesVolcadosService.getDataTablaCamionesVolcados(moment(fechaActualizada).format('YYYY-MM-DD')).then(callback)
    function callback (result) {
      const data = []
      result.forEach(d => { data.push({ ...d, cartadeporte: d.cartaDePorteAutomotor }) })
      const customToolbar = pdfCustomToolbarGenerator(
        'Listado camiones volcados',
        data,
        COLUMNS_CAMIONES_VOLCADOS_TO_PRINT,
        'landscape')
      dispatch({
        type: 'UPDATE_MUITABLE',
        newState: {
          columns: COLUMNS_CAMIONES_VOLCADOS,
          data: data,
          title: `Listado camiones volcados`,
          isLoading: false,
          fixed2Decimales: false,
          extraOptions: {
            customToolbar,
            print: false,
            pagination: false,
            tableBodyMaxHeight: '499px'
          }
        },
        id: TABLA_CAMIONES_VOLCADOS
      })
    }
  }
}
